import axios from "axios";

/**
 * Formats a date to local date-time string (YYYY-MM-DDTHH:mm:ss.sss) for audit/event date pickers.
 */
function toLocalDateTimeString(date) {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    const h = String(date.getHours()).padStart(2, "0");
    const min = String(date.getMinutes()).padStart(2, "0");
    const s = String(date.getSeconds()).padStart(2, "0");
    const ms = String(date.getMilliseconds()).padStart(3, "0");
    return `${y}-${m}-${d}T${h}:${min}:${s}.${ms}`;
}

/**
 * Sets default filter values in localStorage (from trafficV2, auditV2, eventV2).
 * Keys match page localStorageKey; values are JSON arrays/objects as used by filters.
 */
export function setDefaultFiltersStorage() {
    localStorage.setItem("trafficV2_traffic type", JSON.stringify(["browsing"]));
    localStorage.setItem("eventV2_verdict", JSON.stringify(["Blocked", "Detected"]));
    // auditV2 default is only date_picker, set in setDefaultDatePickerStorage
}

/**
 * Sets default date picker values in localStorage (past 24h → now).
 * trafficV2 uses UTC; auditV2 and eventV2 use local time.
 */
export function setDefaultDatePickerStorage() {
    const now = new Date();
    const past24h = new Date(now.getTime() - 24 * 60 * 60 * 1000);

    const trafficValue = [
        { start_date: past24h.toISOString(), end_date: now.toISOString(), quickLabel: 'Last 24 hours' },
    ];
    localStorage.setItem("trafficV2_date_picker", JSON.stringify(trafficValue));

    const auditValue = [
        { start_date: toLocalDateTimeString(past24h), end_date: toLocalDateTimeString(now), quickLabel: 'Last 24 hours' },
    ];
    localStorage.setItem("auditV2_date_picker", JSON.stringify(auditValue));

    const eventValue = [
        { start_date: toLocalDateTimeString(past24h), end_date: toLocalDateTimeString(now), quickLabel: 'Last 24 hours' },
    ];
    localStorage.setItem("eventV2_date_picker", JSON.stringify(eventValue));
}

class AuthService {
    login(username, password, clientid, errorCallback) {
        return axios.post(window.config.API_URL + "login", { username, password, clientid }).then(
            (response) => {
                localStorage.setItem("reduxState",
                    JSON.stringify({
                        "auth": { "username": response.data.username, "email": response.data?.email, "token": response.data.token, "refresh": response.data.refresh },
                        "header": { "isOpen": false }
                    }));
                setDefaultFiltersStorage();
                // setDefaultDatePickerStorage();
                return true;
            },
            (error) => {
                errorCallback(error);
                localStorage.removeItem("reduxState");
                localStorage.removeItem("eventV2_verdict");
                localStorage.removeItem("trafficV2_traffic type");
                return false;
            }
        );
    }

    refresh() {
        let me = JSON.parse(localStorage.getItem("reduxState"));

        let headers_config = {
            headers: {
                'Authorization': 'Bearer ' + me.auth.refresh
            }
        }

        return axios.post(window.config.API_URL + "refresh", {}, headers_config).then(
            (response) => {
                localStorage.setItem("reduxState",
                    JSON.stringify({
                        "auth": { "username": response.data.username, "email": response.data.email, "token": response.data.token, "refresh": response.data.refresh },
                        "header": { "isOpen": false }
                    }));
            },
            (error) => {
                localStorage.removeItem("reduxState");
                window.location = "/login";
            }
        );
    }
}

export default new AuthService();
